<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-6 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

        <!--==========Class dropdown============-->
      <div class="col-md-2">
      
      </div>
        <!---SEARCH BOX-->
         <div class="col-md-3">
          <div class="searchbox input-group" role="group">
            <input class="form-control search-box my-search-box" type="text" placeholder="Search by Name" aria-label="search" v-model="filteredText">
            <button class="search-button btn btn-primary filter"  @click="getRoles()"><i class="fa fa-search search-icon"></i></button>
          </div>
          
        </div>
        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddRoleModal>Add </div>
            </div>
          </a>
        </div> 


     
       </div>
       <div class="row"><div class="col"><hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;"></div></div>
      <div>
        <div class="row">
          <div class="col">
            <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
              style="font-size: 85%;">
                <thead>
                  <tr>
                    <th role="columnheader" >Role Name</th>
                    <th  role="columnheader" >Company</th>
                    <th role="columnheader" >Rights</th>
                    <th role="columnheader">Actions</th>
                  </tr>
                </thead>
                <tbody>

                  <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
                  <tr v-if= "Roles===null" >
                    <td colspan="3" style = "color :red">No data</td>
                  </tr>
                <tr v-else v-for="role in Roles" :key= role.roleId>
                    <td  role="cell">
                    {{role.roleName}}
                    </td>
                    <td  role="cell">
                    {{role.companyName}}
                    </td>
                  <td>
                      <div v-for = "rights in role.roleRights" :key = rights.headingName>
                        <b>{{rights.headingName}}</b>
                        <p v-for = "menu in rights.rights" :key = menu.rightId class = "p-margin">{{menu.rightName}}</p>
                      </div> 
                  </td>
                    <td>
                      <span @click= "passRecordToEdit(role)">
                        <i role="button" style="color:green" class="far fa-edit"></i>&nbsp;|&nbsp;
                      </span>
                      <span @click= "passRecordToDelete(role.roleId)">
                        <i role="button" style="color:green" class="far fa-trash-alt"></i>
                      </span>
                    </td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getRoles()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
         <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>
       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
      <AddRoleModal/>
    <EditRoleModal v-if = "roleToEdit != null" :role = "roleToEdit"/>
    <DeleteModal :entityId = "roleToDelete" heading = "Delete Role" msgForBox = "Role has been deleted successfully" msgForModal ="Confirm to delete" apiEndPoint="/role/delete/" />

  
  
  
  
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddRoleModal from '../../modals/AddRoleModal'
import DeleteModal from '../../modals/DeleteModal'
import EditRoleModal from '../../modals/EditRoleModal'
import { setTimeout } from 'timers';
export default {
    name: 'Roles',
    data(){
        return{
          moduleName:'Roles',
          Id:null,
          roleToEdit :  null,
          roleToDelete:null,
          Roles:[''],
          isLoading:true,
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25
		}
  },
 computed:{
        
  },
methods:{
 
  
  passRecordToDelete(id)
  {
    console.log(id)
    this.roleToDelete = id;
    this.$bvModal.show('DeleteModal')

  },
  passRecordToEdit(role)
  {
    this.roleToEdit = role;
    setTimeout(
      () => {
     this.$bvModal.show('EditRoleModal')
  },150)
    
    // console.log(this.userToEdit)
  },
    getRoles(){
      this.isLoading = true;
      axios.post('/role/getRolesWithRights',{"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      this.isLoading = false;
      this.Roles=res.data.data;
       this.rows = res.data.totalRecords
    });
  },
	
 
     getPage(page)
  {
    this.page = page;
    this.getRoles();
  },
   
  search(){
   
    this.page=this.pageNumOnSearch;
    this.getRoles();
  }
  },
	created(){
    this.getRoles();
   
  },
  components:{
    Spinner,
    AddRoleModal,
    EditRoleModal,
    DeleteModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.p-margin{
 margin: 3px 0px 0px 5px !important;
   
}
.row{
  margin-left:0px;
  margin-right:0px;
}

.col{
  padding-left:0px;
  padding-right:0px;
}

</style>


